import { render, staticRenderFns } from "./Recollect.vue?vue&type=template&id=3dbc7dd2"
import script from "./Recollect.vue?vue&type=script&lang=js"
export * from "./Recollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports